// extracted by mini-css-extract-plugin
export default {"modalBody":"AuthorityProcessLog_modalBody__mpzsf"};